import {Component, Inject, ViewEncapsulation} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {DialogConfig} from '../dialog.types';


@Component({
    selector: 'app-select-dialog',
    templateUrl: './select-dialog.component.html',
    styles       : [
        /* language=SCSS */
        `
            .fuse-confirmation-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-dialog-container {
                    padding: 0 !important;
                }
            }
        `
    ],
    encapsulation: ViewEncapsulation.None
})
export class SelectDialogComponent {
    selectionForm: FormGroup;
    values: string[] = [];
    dialogTitle: string;
    dialogLabel: string;

    constructor(
        public dialogRef: MatDialogRef<SelectDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogConfig,
        private _formBuilder: FormBuilder
    ) {
        this.values = data.values;
        if (data.title) {
            this.dialogTitle = data.title;
            this.dialogLabel = data.label;
        }
        this.selectionForm = this._formBuilder.group({
            result: ['', Validators.required]
        });
    }

    onCancel(): void {
        this.dialogRef.close({action: 'cancelled',
            selection: null
        });
    }

    onConfirm(): void {
        if (this.selectionForm.valid) {
            this.dialogRef.close({action: 'confirmed',
                selection: this.selectionForm.get('result').value
            });
        }
    }


    onNo(): void {
        if (this.selectionForm.valid) {
            this.dialogRef.close({action: 'no',
                selection: this.selectionForm.get('result').value
            });
        }else{
            this.dialogRef.close({action: 'no',
                selection: null
            });
        }

    }
}
